import { render, staticRenderFns } from "./Produitn2.vue?vue&type=template&id=ddadc0b8&scoped=true&"
import script from "./Produitn2.vue?vue&type=script&lang=js&"
export * from "./Produitn2.vue?vue&type=script&lang=js&"
import style0 from "./Produitn2.vue?vue&type=style&index=0&id=ddadc0b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddadc0b8",
  null
  
)

export default component.exports